export default __webpack_public_path__ + "static/media/clipboard.0e3ae41e.svg";